import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-deploy-activity",
  templateUrl: "./deploy-activity.component.html",
})
export class DeployActivityComponent implements OnInit {
  @Input() public activity: any;
  public showNested: boolean;
  public visibleSubActivities: any;

  public ngOnInit() {
    this.showNested = false;
  }

  public trackByTrackableId(_index: number, subActivity: any) {
    return subActivity.trackableId;
  }

  public toggleShowNested() {
    // This ensures we only render the subActivities when we need them.
    // Otherwise, it can have a huge performance impact.
    this.visibleSubActivities = this.activity.subActivities;
    this.showNested = !this.showNested;
  }
}
